export default {"src":"/_next/static/media/chevronLeft.43315884.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};